module.exports = __webpack_public_path__ + "static/grung_green_bloop-63b0ca33f02f1e705cbcfe78189ebb35.jpg";